// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import petitionStatusEntity from './entities/petition-status.json';
import petitionStatusMenu from '../pages/petition-status/menu.json';
import petitionStatusFullForm from '../pages/petition-status/forms/full.json';
import petitionStatusContextForm from '../pages/petition-status/forms/context.json';
import petitionStatusMiniForm from '../pages/petition-status/forms/mini.json';
import petitionStatusLookupForm from '../pages/petition-status/forms/lookup.json';
import petitionStatusTableView from '../pages/petition-status/views/table.json';
import petitionStatusDashboardView from '../pages/petition-status/views/dashboard.json';

/** Тип запису «Статус петиції» зі сторінками пакета: меню, форми та подання з pages/petition-status/. */
export const petitionStatusDefinition: IRecordTypeDefinition = {
  ...petitionStatusEntity,
  views: assembleViewSet({
      table: petitionStatusTableView,
      dashboard: petitionStatusDashboardView,
  }),
  form: petitionStatusFullForm,
  forms: { full: petitionStatusFullForm, context: petitionStatusContextForm, mini: petitionStatusMiniForm, lookup: petitionStatusLookupForm },
  menu: petitionStatusMenu,
} as IRecordTypeDefinition;
